module.exports = __webpack_public_path__ + "static/assets/breno-assis-r3WAWU5Fi5Q-unsplash.1880c9a4.jpg";